module.exports = __webpack_public_path__ + "img/character.1195085e.png";